// UserActions.js
import axios from "axios";
import { url } from "../utils/const";

/**
 * Haal de Mendix-user op
 * Deze user bevat isManager, naam, saldo, etc.
 * Backend haalt zelf email uit JWT.
 */
export const fetchMendixUser = () => (dispatch) => {

    const token = localStorage.getItem("jwtToken");
    if (!token) {
        console.error("❌ Geen JWT token gevonden");
        return Promise.reject("Geen token");
    }

    const endpoint = url + "/api/v1/proxy/mendix/user";

    console.log("🔎 FETCH MENDIX USER →", endpoint);

    return axios.get(endpoint)
        .then(res => {
            console.log("✅ MENDIX USER LOADED:", res.data);

            dispatch({
                type: "FETCH_MENDIX_USER",
                payload: res.data
            });

            return res.data;
        })
		.catch(err => {
			console.error("❌ Error fetching Mendix user:", err);

			if (err.response && err.response.status === 500) {
				return Promise.reject("MENDIX_UNAVAILABLE");
			}

			return Promise.reject(err);
		});
};